import { Row } from "antd";
import OrderLines from "./OrderLines";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import "dayjs/locale/en"; // for fallback
import weekday from "dayjs/plugin/weekday";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(weekday);
dayjs.extend(localizedFormat);

interface Slot {
  id: number;
  start_date: string;
  finish_date: string;
  is_available: boolean;
}

interface Props {
  car?: string;
  slot?: Slot;
  branch?: any;
  /** Wizard step on /order — adjusts sidebar hint copy */
  wizardStep?: 1 | 2 | 3;
}

const Summary = ({
  car,
  branch,
  slot,
  wizardStep = 1,
}: Props) => {
  const { t, i18n } = useTranslation();

  const hasBranchChoice =
    branch !== -1 &&
    branch !== "" &&
    branch !== undefined &&
    branch !== null;

  const showDefaultHeader = !car || !hasBranchChoice || !slot;
  const showPickTimeOnlyHint = Boolean(
    car && hasBranchChoice && !slot
  );

  const sidebarHint = (() => {
    if (wizardStep === 3) return t("profile.order.summaryStep3Hint");
    if (wizardStep === 2 && showPickTimeOnlyHint) {
      return t("profile.order.summaryNextPickTime");
    }
    return t("profile.order.summaryHint");
  })();

  const formattedDate = slot
    ? dayjs(slot.start_date)
        .locale(i18n.language)
        .format("dddd DD/MM/YYYY")
    : "";

  const formattedTime = slot
    ? dayjs(slot.start_date)
        .locale(i18n.language)
        .format("hh:mm A")
    : "";

  return (
    <aside className="ac-order-summary">
      <div className="ac--summary-header ac-order-summary__header">
        {showDefaultHeader ? (
          <>
            <Row gutter={16}>
              <span className="ac--summary-title ac-order-summary__title">
                {t("profile.order.title")}
              </span>
            </Row>
            <p className="ac-order-summary__hint">{sidebarHint}</p>
          </>
        ) : (
          <div className="reservation-box ac-order-summary__appointment">
            <span className="summary-title ac-order-summary__appointment-title">
              {t("profile.order.orderDetails.appointmentS")}
            </span>
            <dl className="ac-order-summary__dl">
              <div className="ac-order-summary__row">
                <dt>{t("profile.order.vehicleS")}</dt>
                <dd>{car}</dd>
              </div>
              <div className="ac-order-summary__row">
                <dt>{t("profile.order.branchS")}</dt>
                <dd>{branch}</dd>
              </div>
              <div className="ac-order-summary__row">
                <dt>{t("result.date")}</dt>
                <dd>{formattedDate}</dd>
              </div>
              <div className="ac-order-summary__row">
                <dt>{t("result.time")}</dt>
                <dd>{formattedTime}</dd>
              </div>
            </dl>
          </div>
        )}
      </div>

      <div className="ac--summary-container ac-order-summary__body">
        <OrderLines />
      </div>
    </aside>
  );
};

export default Summary;
